const ADD_ON_DETAILS_MODES = Object.freeze({
  REMOVE: 'REMOVE',
  BUY: 'BUY',
  REQUEST: 'REQUEST',
  CANCEL_REQUEST: 'CANCEL_REQUEST',
});

const ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES = Object.freeze({
  REMOVE: 'REMOVE',
  BUY: 'BUY',
  EDIT: 'EDIT',
  REQUEST: 'REQUEST',
  CANCEL_REQUEST: 'CANCEL_REQUEST',
});

const ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP = {
  CONFIRM: 'CONFIRM',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

const FAILURE_CONFIG = {
  title: 'soho_addons_failure_modal_title',
  description: 'soho_addons_failure_modal_description',
  primaryButtonProps: {
    title: 'soho_addons_failure_modal_try_again',
  },
  secondaryButtonProps: {
    title: 'soho_addons_failure_modal_close',
  },
};

const ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG = Object.freeze({
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.REMOVE]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_removing_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_remove_quick_action_title',
      description: 'soho_addons_remove_quick_action_confirmation_description',
      hint: 'soho_addons_remove_quick_action_hint',
      confirmButtonTitle: 'soho_addons_remove_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_remove_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_remove_success_modal_title',
      description: 'soho_addons_remove_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
  },
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.BUY]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_buy_quick_action_title',
      description: 'soho_addons_buy_quick_action_confirmation_description',
      hint: 'soho_addons_buy_quick_action_hint',
      confirmButtonTitle: 'soho_addons_buy_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_buy_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_success_modal_title',
      description: 'soho_addons_buy_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
  },
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.EDIT]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_success_modal_title',
      description: 'soho_addons_edit_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_edit_user_quick_action_title',
      description: 'soho_addons_edit_user_quick_action_confirmation_description',
      hint: 'soho_addons_edit_user_quick_action_hint',
      secondHint: 'soho_addons_edit_user_quick_action_hint_second_paragraph',
      confirmButtonTitle: 'soho_addons_edit_user_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_edit_user_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
  },
});

const PROFILE_ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG = Object.freeze({
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.REMOVE]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_remove_success_modal_title',
      description: 'soho_addons_remove_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_remove_quick_action_title',
      description: 'soho_profile_addons_remove_quick_action_description',
      hint: 'soho_profile_addons_remove_quick_action_hint',
      confirmButtonTitle: 'soho_addons_remove_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_remove_quick_action_cancel_button_title',
    },
  },
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.BUY]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_buy_quick_action_title',
      description: 'soho_profile_addons_buy_quick_action_description',
      hint: 'soho_profile_addons_buy_quick_action_hint',
      confirmButtonTitle: 'soho_addons_buy_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_buy_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_success_modal_title',
      description: 'soho_addons_buy_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
  },
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.REQUEST]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_request_quick_action_title',
      description: 'soho_profile_addons_request_quick_action_description',
      hint: 'soho_profile_addons_request_quick_action_hint',
      confirmButtonTitle: 'soho_addons_request_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_request_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_request_success_modal_title',
      description: 'soho_addons_request_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
  },
  [ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.CANCEL_REQUEST]: {
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_addons_cancel_request_success_modal_title',
      description: 'soho_addons_cancel_request_success_modal_description',
      primaryButtonProps: {
        title: 'soho_addons_success_modal_return_to_addons',
      },
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_addons_cancel_request_quick_action_title',
      description: 'soho_profile_addons_cancel_request_quick_action_description',
      confirmButtonTitle: 'soho_addons_request_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_addons_request_quick_action_cancel_button_title',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_addons_modal_loading_screen_subtitle',
    },
    [ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP.FAILURE]: FAILURE_CONFIG,
  },
});

export {
  ADD_ON_DETAILS_MODES,
  ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES,
  ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG,
  ADD_ON_DETAILS_QUICK_ACTION_MENU_STEP,
  PROFILE_ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG,
};
